<template>
  <div
    class="anime-title-box"
    ref="titleBox"
    data-animation="fade-scale-up"
    data-once="false"
  >
    <div class="anime-title-svg">
      <span class="title-text" v-html="processedTitle"></span>
      <span class="title-text" v-if="secondTitle" v-html="processedSecondTitle"></span>
      <!-- <AnimatedSVGTitle svgRefValue: :text="computingTitle"
      :refValue="svgRefValue" :matchedStyle="matchedTexts[0]" /> -->
    </div>

    <!-- <span class="computing-title-text">{{ computingTitle }}</span> -->
  </div>
</template>
<script>
import AnimatedSVGTitle from '@/components/AnimatedSVGTitle/index.vue';
export default {
  components: {
    AnimatedSVGTitle,
  },
  props: {
    svgRefValue: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '首页',
    },
    secondTitle: {
      type: String,
      default: '',
    },
    computingTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    processedTitle() {
      return this.highlightMatchingText(this.title, this.computingTitle);
    },
    processedSecondTitle() {
      return this.highlightMatchingText(this.secondTitle, this.computingTitle);
    }
  },
  mounted() {},

  methods: {
    highlightMatchingText(text, computingTitle) {
      if (!text || !computingTitle) return text;
      
      // Create a regex pattern that matches the computingTitle (case-insensitive)
      const regex = new RegExp(`(${this.escapeRegExp(computingTitle)})`, 'gi');
      
      // Replace matching text with styled span
      return text.replace(regex, '<span class="highlighted-text">$1</span>');
    },
    
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  },
};
</script>
<style lang="scss" scoped>
.anime-title-box {
  font-family: 'MiSans-Semibold';
  font-size: 56px;
  color: #222226;
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;

  .title-text,
  .computing-title-text {
    display: inline-block;
    white-space: nowrap;
  }
  
  .anime-title-svg {
    position: relative;
  }
  
  :deep(.highlighted-text) {
    background: linear-gradient(35.342353434743124deg, #005FE6 0%, #2EB6D8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
  }
}
</style>
